import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import WorkspaceService from "@core-ui/ContextServices/Workspace";
import { usePlatform } from "@core-ui/hooks/usePlatform";
import PermissionService from "@ext/security/logic/Permission/components/PermissionService";
import { configureWorkspacePermission } from "@ext/security/logic/Permission/Permissions";
import { useMemo } from "react";

const useShouldRenderDeleteCatalog = () => {
	const workspacePath = WorkspaceService.current()?.path;
	const { cloudServiceUrl } = PageDataContextService.value.conf;

	const canConfigureWorkspace = PermissionService.useCheckPermission(configureWorkspacePermission, workspacePath);
	const { environment } = usePlatform();

	const shouldRenderDeleteCatalog = useMemo(() => {
		switch (environment) {
			case "next":
				return canConfigureWorkspace;
			case "web":
				return true;
			case "tauri":
				return true;
			case "static":
				return !!cloudServiceUrl;
			case "cli":
				return false;
		}
	}, [canConfigureWorkspace, cloudServiceUrl, environment]);

	return shouldRenderDeleteCatalog;
};

export default useShouldRenderDeleteCatalog;
